import React from 'react';
import {InfoCircleOutlined} from '@ant-design/icons';
import {Card, Col, Row, Spin, Tooltip, Typography} from 'antd';

import ErrorBoundary from '../ErrorBoundary';

import './AccountDetails.less';
import {useAppSelector} from '../../hooks/useStore';
import {selectActiveAccount} from '../../store/slices/userSlice';

const {Text} = Typography;

const AccountDetailsCard = () => {
    const activeAccount = useAppSelector(selectActiveAccount);

    return (
        <Spin spinning={!activeAccount}>
            <Card
                title={<><span>Account Details</span></>}
                className="details-card"
            >
                <ErrorBoundary>
                    <Row>
                        <Col span={24}>
                            <Text strong>Account Number:</Text>
                            <Tooltip title="This is your current account number">
                                <InfoCircleOutlined />
                            </Tooltip>
                        </Col>
                        <Col span={24}>
                            <Text>{activeAccount?.account_number ?? 'N/A'}</Text>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}>
                            <Text strong>Price Plan:</Text>
                        </Col>
                        <Col span={24}>
                            <Text>{activeAccount?.account_price_plan?.name ?? 'N/A'}</Text>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}>
                            <Text strong>Account Owners:</Text>
                        </Col>
                        <Col span={24}>
                            {
                                activeAccount?.account_owner_names && activeAccount.account_owner_names.length !== 0 ?
                                    activeAccount.account_owner_names.map((owner, index) => (
                                        <span className="account-owner-name long-text-wrap" key={index}>
                                            {owner ?? 'N/A'}
                                            {index !== activeAccount.account_owner_names.length - 1 ? ', ' : ''}
                                        </span>
                                    ))
                                    : 'N/A'
                            }
                        </Col>
                    </Row>
                </ErrorBoundary>
            </Card>
        </Spin>
    );
};

export default AccountDetailsCard;
